module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am0-4d612c37a57afdcfd8558c9cfcd327cf.jpg";